module.exports = __webpack_public_path__ + "img/flow-horizontal.08a63bd.svg";